import { useDispatch } from 'react-redux'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { MARKER_TYPES, setType } from '~map-preview/states/marker'

import { useEffect } from 'react'
import {
  LAYER_TYPES,
  LAYER_TYPE_TITLE,
  setLayerType,
  setLayerTypeTitle
} from '~map-preview/states/layerType'
import { closeMapLegend } from '~map-preview/states/ui'

export function Cluster() {
  const { visualization } = useMapToolbarStore()
  const dispatch = useDispatch()

  useEffect(() => {
    if (visualization) {
      const selected = visualization && Object.values(visualization)[0]
      if (selected?.id === 'cluster') {
        dispatch(setLayerType(LAYER_TYPES.MARKER))
        dispatch(setType(MARKER_TYPES.CLUSTERS))
        dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.MARKER]))
        dispatch(closeMapLegend())
      }
    }
  }, [visualization])

  return null
}
